import { FC, useMemo } from "react";

import { getEventStatusIcons } from "Bands/utils";
import { IEvent } from "Bands/types";
import { FlexContainer, Icon, MutedText, TinyText } from "shared/styles";

type PartialEvent = Pick<IEvent, "status">;

interface CalendarListStatusProps extends PartialEvent {}

export const CalendarListStatus: FC<CalendarListStatusProps> = ({ status }) => {
  const statusIcon = useMemo(() => getEventStatusIcons(status), [status]);

  return (
    <FlexContainer>
      <Icon size="m" as={statusIcon.icon} color={statusIcon.color} />
      <MutedText as={TinyText}>{status}</MutedText>
    </FlexContainer>
  );
};
